import { cloudinary } from '@trmediaab/zebra-utils';

import { breakpoints } from '~/utils/media';

const mediaSizes = { full: 720, aside: [720 * (40 / 100), 800] };

export default function transformHtml(html) {
  const re = /<!--data-trais([\S\s]*?)-->/gm;

  const { full, aside } = mediaSizes;
  // Replace special comments with img tags
  return html.replaceAll(re, (match, p) => {
    try {
      // Parse content inside comment
      const { type, alt, view_mode, cdn_id } = JSON.parse(p);
      if (type !== 'image') {
        throw new Error(`The data-trais type '${type}' is unknown`);
      }
      const scaledWidth = view_mode === 'side' ? aside : full;

      const src =
        view_mode === 'side'
          ? aside.map(
              (ratio, index) =>
                `${`${cloudinary.getUrl(cdn_id, ratio)} ${aside[index]}`}w`,
            )
          : cloudinary.getUrl(cdn_id, scaledWidth);

      return view_mode === 'side'
        ? `<img srcset="${src}" sizes="(max-width:${breakpoints.phone}px)` +
            ` ${aside[1]}px, ${aside[0]}px" src="${src[0]}" alt="${alt}"> `
        : `<img class="full-width" src="${src}" alt="${alt}">`;
    } catch (error) {
      console.warn(error.message);
      return match;
    }
  });
}
